import { Box, Paper, Typography } from '@mui/material';
import { get } from 'lodash';
import React, { FC } from 'react';
import { useFoerderProgramm } from '../../../../../context/FoerderProgrammContext';

// import schemas
import FoerderRichtlinieSchema from '../../../../../lib/paths/foerderrichtlinie_DETAILS_SEITE_Paths.json';
let FR_P = FoerderRichtlinieSchema.attributes;

const FoerdermittelgeberSection: FC<{}> = () => {
	const { foerderRichtlinieDetails } = useFoerderProgramm();
	return (
		<Paper sx={{ p: '2rem' }}>
			<Typography sx={{ fontWeight: 600 }}>Fördermittelgeber</Typography>
			<Box sx={{ mt: '1rem' }}>
				<Typography>
					{get(foerderRichtlinieDetails, FR_P.Foerdermittelgeber.schema.attributes.Geschaeftsbezogene_Daten_Name_Der_Organisation.path)}
				</Typography>
			</Box>
		</Paper>
	);
};

export default FoerdermittelgeberSection;
